import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Error from "./ErrorPage";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import FloatingInstagram from "./components/FloatingInstagram";
import Blogs from "./pages/blogs/Blogs";
import TestimonialsPage from "./pages/testimonials/TestimonialsPage";
import { data } from "./helper/data";
import Contact from "./pages/Contact";
import About from "./pages/About";
import BlogPage from "./pages/blogs/BlogPage";
import RefundAndCancellationPolicy from "./pages/RefundAndCancellationPolicy";
import Onder from "./pages/Onder";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/blogs",
    element: <Blogs />,
  },
  {
    path: "/blog/:id",
    element: <BlogPage />,
  },
  {
    path: "/testimonials",
    element: <TestimonialsPage />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact-us",
    element: <Contact />,
  },
  {
    path: "/order/:pid",
    element: <Onder />,
  },
  {
    path: "/refund-Cancellation-policy",
    element: <RefundAndCancellationPolicy />,
  },
  {
    path: "*",
    element: <Error />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <FloatingWhatsApp
      phoneNumber={data.phoneNumber}
      accountName={data.name}
      avatar={data.pic}
      allowClickAway={true}
      allowEsc={true}
    />
    <FloatingInstagram />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
